/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext, useState
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputNumberField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './QuantityComponent.module.scss';
import metadata from './QuantityComponent.metadata.json5';

function QuantityComponent(props) {

    const {
        data: QuantityVM,
        updateWizardData,
        submissionVM,
        QuantityPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const[total, setTotal] = useState(0);

    const addQuantity = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            QuantityVM.value = QuantityVM.value || []

            const { _xCenter, _dtoName } = QuantityVM;

            const QuantityObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            QuantityVM.isValidationReq.value = true;

            QuantityVM.pushElement(
                QuantityObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, QuantityVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            QuantityVM.value.splice(index, 1);
            _.set(submissionVM.value, QuantityPath, QuantityVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, QuantityPath, QuantityVM?.value]
    );

    const calculateTotalQuantity = useCallback(
        (val, changedPath, index) => {
        let sum = 0

        QuantityVM.value.forEach(element => {
            if (!_.isUndefined(element.memFie)) {
                sum += element.memFie
            }

            if (!_.isUndefined(element.stuFie)) {
                sum += element.stuFie
            }

            if (!_.isUndefined(element.strTraFie)) {
                sum += element.strTraFie
            }

            if (!_.isUndefined(element.aquTraFie)) {
                sum += element.aquTraFie
            }
        })
        setTotal(sum);
        QuantityVM.value[0].totFie = sum;
        handleValueChange(val, changedPath, index);
    }, [QuantityVM, handleValueChange])

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'memFie') {
                const value = !_.isUndefined(item.memFie) ? item.memFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.memFie = val;
                            calculateTotalQuantity(val, changedPath, index)
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'stuFie') {
                const value = !_.isUndefined(item.stuFie) ? item.stuFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.stuFie = val;
                            calculateTotalQuantity(val, changedPath, index)
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'strTraFie') {
                const value = !_.isUndefined(item.strTraFie) ? item.strTraFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.strTraFie = val;
                            calculateTotalQuantity(val, changedPath, index)
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'aquTraFie') {
                const value = !_.isUndefined(item.aquTraFie) ? item.aquTraFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.aquTraFie = val;
                            calculateTotalQuantity(val, changedPath, index)
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'totFie') {
                const value = !_.isUndefined(item.totFie) ? item.totFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"                        
                        value={total === 0 ? value : total}
                        readOnly
                    />
                );
            }
        }, [calculateTotalQuantity, total])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`QuantityTable`]: {
            data: QuantityVM.value,
        }

    }), [QuantityVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addQuantity,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            QuantityVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [QuantityVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={QuantityVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

QuantityComponent.propTypes = wizardProps;
export default withRouter(QuantityComponent);
